// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-card .card-img-overlay{background-color:rgba(0,0,0,.5)}", "",{"version":3,"sources":["webpack://./resources/js/Components/Index/ImageCard.vue"],"names":[],"mappings":"AAEQ,8BACI,+BADZ","sourcesContent":["\n    .image-card {\n        .card-img-overlay {\n            background-color: rgba(0,0,0,0.5);\n        }\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
